import { Directive, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appRemovefirstspace]'
})
export class RemovefirstspaceDirective {

  constructor(@Optional() private formControl: NgControl) { }

  @HostListener('input', ['$event']) onInput(event: any) {

    if(this.formControl.control!.value) {
      const valueArray = this.formControl.control!.value.split('');
      if(valueArray[0] != ' ') {
        return;
      } else {
        if (this.formControl) {
          let indexInitial = valueArray.findIndex((val: string) => {
            return val != ' '
          });
          indexInitial = indexInitial <= 0 ? 1 : indexInitial;
          this.formControl.control!.patchValue(this.formControl.control!.value.substring(indexInitial, this.formControl.control!.value.length));
        }
      }
    }
  }

}
